module.exports = __webpack_public_path__ + "assets/img/authority-2.c7794cc6.svg";